import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const CircleImagesAnimation = () => {
  const containers = document.querySelectorAll(".circle-images");
  if (containers.length < 1) {
    return;
  }

  const reduceMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;
  if (reduceMotion) return;

  const base = {
    y: 0,
    opacity: 1,
    duration: 1,
    ease: "power2.inOut",
  };

  const applyAnimations = () => {
    containers.forEach((container) => {
      const headline = container.querySelectorAll(".circle-images__headline");
      const subline = container.querySelectorAll(".circle-images__subline");
      const icon = container.querySelectorAll(".text-container__icon");
      const text = container.querySelectorAll(".text-container__text");
      const circleImages = container.querySelectorAll(".image-container");

      if (
        !headline.length &&
        !subline.length &&
        !icon.length &&
        !text.length &&
        !circleImages.length
      )
        return;

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: container,
          start: "top 80%",
          once: true,
          fastScrollEnd: true,
        },
      });

      if (headline.length) {
        tl.to(headline, { ...base, x: 0 });
      }

      if (subline.length) {
        tl.to(subline, { ...base, x: 0 }, 0.2);
      }

      if (icon.length) {
        tl.to(icon, {
          scale: 1,
          opacity: 1,
          duration: 1,
          ease: "back.out(1.7, 0.5)",
          stagger: 0.15,
        });
      }

      if (text.length) {
        tl.to(
          text,
          {
            x: 0,
            opacity: 1,
            duration: 1,
            ease: "power2.inOut",
            stagger: 0.15,
          },
          "-=1",
        );
      }

      if (circleImages.length) {
        tl.to(
          circleImages,
          {
            scale: 1,
            opacity: 1,
            duration: 1,
            ease: "back.out(1.7, 0.5)",
            stagger: 0.2,
          },
          "-=1.6",
        );
      }
    });
  };
  applyAnimations();
};

export default CircleImagesAnimation;
